export default __webpack_public_path__ + "static/media/GAF.486ea13c.webp";